module.exports = __webpack_public_path__ + "img/home.ecd8c27e.png";